import { DomainModel } from 'domains/models';
import { FrequencyType } from './frequencyType';

export default class EventTypeCalendar extends DomainModel {
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
  wday: number;
  timeZone: string | null;
  frequencyType: FrequencyType | null;
  frequencyInterval: number | null;
  startedAt: Date;
  endedAt: Date | null;
  exceptions: any;
  schedulableType: string;
  schedulableId: number | null;
  parentEventTypeCalendarId: number | null;

  constructor(props: any) {
    super(props);
    this._className = 'EventTypeCalendar';
    this.startHour = props.startHour;
    this.startMinute = props.startMinute;
    this.endHour = props.endHour;
    this.endMinute = props.endMinute;
    this.wday = props.wday;
    this.timeZone = props.timeZone || null;
    this.frequencyType = props.frequencyType || null;
    this.frequencyInterval = props.frequencyInterval || null;
    this.startedAt = props.startedAt;
    this.endedAt = props.endedAt || null;
    this.schedulableType = props.schedulableType;
    this.schedulableId = props.schedulableId;
    this.parentEventTypeCalendarId = props.parentEventTypeCalendarId || null;
    this.exceptions = props.exceptions;
  }

  isValid() {
    super.beforeValidate();
    const p = '';

    return super.isValid();
  }

  static permited = [
    'startHour',
    'startMinute',
    'endHour',
    'endMinute',
    'wday',
    'frequencyType',
    'frequencyInterval',
    'startedAt',
    'endedAt',
    'exceptions',
  ];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  static defaultCalendar({ wday }: { wday: number }) {
    return new EventTypeCalendar({
      startHour: 10,
      startMinute: 0,
      endHour: 19,
      endMinute: 0,
      wday,
      startedAt: new Date(),
      endedAt: null,
      frequencyType: FrequencyType.Weekly,
      frequencyInterval: 1,
    });
  }
}
